<div class="milestone-row" [ngClass]="{'highlighted': shouldHighlightMilestone}" (click)="openMilestoneView()">
  <div class="milestone-left">
    <ng-container *ngIf="config?.displayStepCounter">
      <span class="milestone-counter">
        {{ 'milestones.step' | translate: { stepNumber: index + 1 } }}
      </span>
    </ng-container>

    <h4 class="milestone-title">
      {{ milestone.name }}
    </h4>

    <ng-container *ngIf="config?.displayDescription">
      <p class="milestone-description">{{ milestone?.description }}</p>
    </ng-container>

    <p *ngIf="(documentsToDisplay?.length || milestone.notes?.length || milestoneForm) && !shouldHighlightMilestone" class="milestone-subtitle">
      <!-- Form -->
      <span *ngIf="milestoneForm">
          <span *ngIf="formValid">
            {{ 'milestones.form.form-completed' | translate }}
          </span>
          <span *ngIf="!formValid" class="text-gray">
            {{ 'milestones.form.form-incomplete' | translate }}
          </span>
          <span *ngIf="milestone.notes?.length || documentsToDisplay?.length" class="text-gray">
            |
          </span>
      </span>

      <!-- Notes -->
      <span *ngIf="milestone.notes?.length">
        {{ milestone.notes.length }}
        <span *ngIf="milestone.notes.length === 1">{{ 'milestones.note' | translate }}</span>
        <span *ngIf="milestone.notes.length > 1">{{ 'milestones.notes' | translate }}</span>
      </span>
      <span *ngIf="milestone.notes?.length && documentsToDisplay?.length">
        {{ 'milestones.and' | translate }}
      </span>
      <span *ngIf="documentsToDisplay?.length">
        {{ documentsToDisplay.length }}
        <span *ngIf="documentsToDisplay.length === 1"> {{ 'milestones.attachment' | translate }}</span>
        <span *ngIf="documentsToDisplay.length > 1"> {{ 'milestones.attachments' | translate }}</span>
      </span>
    </p>

    <!-- Highlighted area -->
    <ng-container *ngIf="milestoneForm && shouldHighlightMilestone">
      <div class="highlighted-container">
        <button type="button" class="btn btn-primary btn-sm complete-form-button">
          {{ 'milestones.form.submit-form' | translate }}
          <img
            ngSrc="/assets/icons/line-icons/shared/white/arrow-right.svg"
            width="14"
            height="14"
            alt="Complete form"
          />
        </button>

        <span class="highlighted-texts">
          <!-- Form Status -->
          <span *ngIf="formValid">
            {{ 'milestones.form.form-completed' | translate }}
          </span>
          <span *ngIf="!formValid" class="text-gray">
            {{ 'milestones.form.form-incomplete' | translate }}
          </span>
          <span *ngIf="milestone.notes?.length || documentsToDisplay?.length" class="text-gray">
            |
          </span>
          <!-- /Form Status -->

          <!-- Notes -->
          <span class="highlighted-texts" *ngIf="milestone.notes?.length">
            {{ milestone.notes.length }}
            <span *ngIf="milestone.notes.length === 1">{{ 'milestones.note' | translate }}</span>
            <span *ngIf="milestone.notes.length > 1">{{ 'milestones.notes' | translate }}</span>
          </span>

          <span *ngIf="milestone.notes?.length && documentsToDisplay?.length">
            {{ 'milestones.and' | translate }}
          </span>

          <span *ngIf="documentsToDisplay?.length">
            {{ documentsToDisplay.length }}
            <span *ngIf="documentsToDisplay.length === 1"> {{ 'milestones.attachment' | translate }}</span>
            <span *ngIf="documentsToDisplay.length > 1"> {{ 'milestones.attachments' | translate }}</span>
          </span>
          <!-- /Notes -->
        </span>
      </div>
    </ng-container>
    <!-- /Highlighted area -->
  </div>

  <!-- Status -->
  <p class="status">
    <oes-milestone-status-dropdown
      [milestone]="milestone"
      [milestoneStatus]="milestoneStatus"
      [initialStatusSelection]="initialStatusSelection"
      [statusDropdownOptions]="statusDropdownOptions"
      [project]="project"
      (statusChanged)="statusChanged($event)"
    />
  </p>
</div>

<oes-side-drawer [isOpen]="milestoneViewShowing" (close)="closeMilestoneView()" #sideDrawer>
  <ng-container *ngIf="milestoneViewAfterAnimation">
    <oes-milestone-view
      [initialStatusSelection]="initialStatusSelection"
      [milestone]="milestone"
      [milestoneForm]="milestoneForm"
      [milestoneStatus]="milestoneStatus"
      [milestoneType]="milestoneType"
      [project]="project"
      [projectOfftaker]="projectOfftaker"
      [projectInstaller]="projectInstaller"
      [statusChanged]="statusChanged"
      [statusDropdownOptions]="statusDropdownOptions"
      (closeMilestoneView)="closeMilestoneView()"
      (formValidOutput)="formValid = $event"
    ></oes-milestone-view>
  </ng-container>
</oes-side-drawer>
